import fs from 'fs-extra'
import path from 'path'
import fetch from 'node-fetch'

const ISC = `Copyright (c) [year], [fullname]

Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.`

const APIPath = 'https://api.github.com/licenses/'
const ghLicensesAPI = {
  "agpl": "agpl-3.0",
  "agpl-3.0": "agpl-3.0",
  "agpl-3": "agpl-3.0",
  "agpl3": "agpl-3.0",
  "agpl": "agpl-3.0",
  "unlicense": "unlicense",
  "epl-2.0": "epl-2.0",
  "epl-2": "epl-2.0",
  "epl2": "epl-2.0",
  "epl": "epl-2.0",
  "mit": "mit",
  "lgpl-2.1": "lgpl-2.1",
  "lgpl-2": "lgpl-2.1",
  "lgpl2": "lgpl-2.1",
  "lgpl": "lgpl-2.1",
  "mpl-2.0": "mpl-2.0",
  "mpl-2": "mpl-2.0",
  "mpl2": "mpl-2.0",
  "apache-2.0": "apache-2.0",
  "apache-2": "apache-2.0",
  "apache2": "apache-2.0",
  "apache": "apache-2.0",
  "gpl-2.0": "gpl-2.0",
  "gpl-2": "gpl-2.0",
  "gpl2": "gpl-2.0",
  "gpl-3.0": "gpl-3.0",
  "gpl-3": "gpl-3.0",
  "gpl3": "gpl-3.0",
  "gpl": "gpl-3.0",
  "bsd-2-clause": "bsd-2-clause",
  "bsd-2": "bsd-2-clause",
  "bsd2": "bsd-2-clause",
  "bsd-3-clause": "bsd-3-clause",
  "bsd-3": "bsd-3-clause",
  "bsd3": "bsd-3-clause",
  "bsd": "bsd-3-clause",
  "lgpl-3.0": "lgpl-3.0",
  "lgpl-3": "lgpl-3.0",
  "lgpl3": "lgpl-3.0",
  "lgpl": "lgpl-3.0"
}

async function ensureLicense (PATHS, pkg) {
  const projectPath = PATHS.project
  const validLicenseFiles = [
    'LICENSE',
    'LICENSE.txt',
    'LICENSE.md'
  ]

  // if there is already a license file, we do nothing
  for (let l in validLicenseFiles) {
    if (await fs.pathExists(path.resolve(projectPath, validLicenseFiles[l]))) {
      return
    }
  }

  // if there is no license file in the project, but there is any in the package
  if (pkg.license) {
    let theLicense = pkg.license.toLowerCase()
    if (theLicense === 'isc') {
      theLicense = ISC
    } else if (ghLicensesAPI[theLicense]) {
      let license = await fetch(APIPath + ghLicensesAPI[theLicense])
      license = JSON.parse(await license.text())
      license = license.body
      theLicense = license
    }

    theLicense = theLicense.replace(/\[year\]/i, (new Date).getFullYear())
    if (pkg.author) {
      theLicense = theLicense.replace(/\[fullname\]/i, pkg.author)
    }

    fs.writeFile(path.resolve(projectPath, validLicenseFiles[0]), theLicense)
  }

}

export default ensureLicense



// WEBPACK FOOTER //
// ./src/license-manager.js